<template>
    <el-dialog :visible.sync="openDialog" custom-class="edit-send-order-dislog" width="calc(100% - 100px)" top="20px" :title="title" :close-on-click-modal="false">
        <div class="form-wrap"></div>
        <div class="table-wrap">
            <el-table :data="tableData" v-loading="loading" border size="mini" :header-cell-style="headerCellStyle" :height="showForm?'calc(100vh - 300px)':'calc(100vh - 223px)'" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="40" align="left"> </el-table-column>
                <el-table-column prop="orderCode" label="订单号"></el-table-column>
                <el-table-column prop="xjOrderCode" label="询价单号"></el-table-column>
                <el-table-column prop="provideDate" label="订单日期"></el-table-column>
                <el-table-column prop="lineNumber" label="订单行号"></el-table-column>
                <el-table-column prop="code" label="物料编码"></el-table-column>
                <el-table-column prop="name" label="物料名称"></el-table-column>
                <el-table-column prop="sspace" label="规格"></el-table-column>
                <el-table-column prop="model" label="型号"></el-table-column>
                <el-table-column prop="num" label="订单数量"></el-table-column>
                <el-table-column prop="remainPlanNumber" label="未送货数量"></el-table-column>
                <!-- <el-table-column prop="a" label="送货日期">
                </el-table-column> -->
                <!-- <el-table-column prop="deliverNum" label="送货数量">
                    <template slot-scope="scope">
                        <el-input  size="mini" v-model="scope.row.deliverNum" @keyup.native="tenderNumChange(scope.row,'deliverNum')" class="table-edit-input"/>
                    </template>
                </el-table-column> -->
            </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="openDialog = false" size="small">取 消</el-button>
            <el-button type="primary" @click="saveInfo" size="small" :disabled="ids.length == 0">创建送货单</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { getListRemainGreatThanZero,addDeliverOrder } from '@/api/transport/index.js'
export default {
    props:[],
    data() {
        return {
            openDialog:false,
            title:'',
            showForm:false,
            // 明细数据
            tableData:[],
            loading:false,
            ids:[],
        };
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    methods: {
        // 获取未发货的明细数据
        getGoodsList(){
            this.ids = [];
            this.loading = true;
            getListRemainGreatThanZero({
                page: 1, //当前页码
                limit: 1000, //当前每页显示的数量
            }).then(({data:res})=>{
                this.tableData = res.data.records || [];
                this.tableData.forEach((item)=>{
                    item['name'] = item.commodity.name;
                    item['code'] = item.commodity.code;
                    item['sspace'] = item.commodity.sspace;
                    item['model'] = item.commodity.model;
                    // item['deliverNum'] = parseInt(item.remainPlanNumber);
                })
                this.loading = false;
                console.log(res)
            })
        },
        // 保存
        saveInfo(){
            let _this = this;
            let idsArr = [];
            this.ids.forEach((id)=>{
                idsArr.push({
                    finalOrderDetailId:id
                })
            })
            addDeliverOrder(idsArr).then(({data:res})=>{
                if(res.code == 0){
                    this.$success('创建成功')
                    setTimeout(()=>{
                        _this.$router.push({path: `/planinfo/${res.data.id}`});
                    },1000)
                }
            })
        },
        handleSelectionChange(val) {
            this.ids = [];
            for (let item of val) {
                this.ids.push(item.id);
            }
        },
        // 整数
        tenderNumChange(row,prop){
            let curVal = row[prop];
            if(curVal){
                curVal = curVal.replace(/[^\.\d]/g, '')
                curVal = curVal.replace('.', '')
            }
            if(curVal>row.remainPlanNumber){
                curVal = row.remainPlanNumber
            }
            row[prop] = curVal;
        },
    },
    watch: {

    },
};
</script>

<style lang="scss">
.edit-send-order-dislog{
    margin-top: 50px!important;
}
</style>
